<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AGBkth/tc-custom/9781631941948.jpg?1726871919700" alt="This image is the cover for the book Who Is Simon Warwick?, Henry Tibbett"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who Is Simon Warwick?, Henry Tibbett
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] playfully old-fashioned merry-go-round of missing heirs, false claimants, and fabricated identities . . . Ingenious and elegant.” —<i>Kirkus Reviews</i></b><br/><br/> Millionaire Lord Charlton altered his will in favor of his nephew, Simon Warwick, who had been adopted by American parents when his own were killed in World War II. When Lord Charlton dies, two men claiming to be Simon Warwick turn up in London to claim the estate. Then one is found dead, and Chief Superintendent Henry Tibbett is faced with a double mystery: Who is the murderer—and who is Simon Warwick?<br/><br/><b>Praise for Patricia Moyes</b><br/><br/> “The author who put the ‘who’ back in whodunit.” —<i>Chicago Daily News</i><br/><br/> “A new queen of crime . . . her name can be mentioned in the same breath as Agatha Christie and Ngaio Marsh.” —<i>Daily Herald</i><br/><br/> “An excellent detective novel in the best British tradition. Superbly handled.” —<i>Columbus Dispatch</i><br/><br/> “Intricate plots, ingenious murders, and skillfully drawn, often hilarious, characters distinguish Patricia Moyes’ writing.” —<i>Mystery Scene</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Moyes
      </h2>
      
      <p class="authorDescription body article">Patricia Moyes (1923-2000) was a British mystery writer best known for her “Henry Tibbet” series of old-fashioned mysteries. During WWII Moyes joined the Royal Air Force and became a radar operator and flight officer. Subsequently, she worked as assistant to actor and director Peter Ustinov, with whom she collaborated on a film script. She also spent some years as assistant editor for British Vogue. A cat lover, Moyes wrote two books about cats.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      FELONY & MAYHEM PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d886bfe